import { ChevronDown } from '@1debit/icons';
import Button from 'components/shared/Buttons/BaseButton';
import { NavContentLinkProps } from './types';
import { MainNavLinkSize } from 'types/constants';
import { cn } from 'utils/styles';
import { generateNavId } from 'components/MainNav/utils';

export interface NavCoreButtonProps {
  linkContent: NavContentLinkProps;
  handleClick: (link: NavContentLinkProps) => void;
}

const NavCoreButtonHorizontal = ({ linkContent, handleClick }: NavCoreButtonProps) => {
  const { linkSize, link } = linkContent;
  if (!link) return null;
  const linkId = generateNavId(link);

  const sharedStyles = cn(
    {
      'text-heading-sm leading-none': linkSize === MainNavLinkSize.Small,
      'text-body-saans leading-1.4 font-medium h-5': linkSize === MainNavLinkSize.Small,
    },
    'active:scale-none',
  );

  return (
    <>
      <Button
        variant="navMenu"
        id={linkId}
        className={cn(sharedStyles, 'flex gap-1 h-full text-kale items-center')}
        onClick={() => handleClick(linkContent)}>
        {link.label}
        <span className="w-6">
          <ChevronDown className="group-hover:inline group-focus:inline size-(--ck-icon-size)" />
        </span>
      </Button>
    </>
  );
};

export default NavCoreButtonHorizontal;
